import { render, staticRenderFns } from "./ConsoleChip.vue?vue&type=template&id=f6528eee"
import script from "./ConsoleChip.vue?vue&type=script&lang=js"
export * from "./ConsoleChip.vue?vue&type=script&lang=js"
import style0 from "./ConsoleChip.vue?vue&type=style&index=0&id=f6528eee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports